import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * when the route changes. This provides a better user experience by ensuring
 * users always start at the top of a new page.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Debug logging for development
    if (import.meta.env.DEV) {
      console.log('🔄 ScrollToTop: Route changed to', pathname);
    }
    
    // Small delay to ensure the new page content has rendered
    const scrollToTop = () => {
      // Check if user prefers reduced motion
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
      
      // Debug logging for development
      if (import.meta.env.DEV) {
        console.log('🔄 ScrollToTop: Scrolled to top for', pathname);
      }
    };

    // Use requestAnimationFrame to ensure smooth execution after render
    const timeoutId = setTimeout(() => {
      requestAnimationFrame(scrollToTop);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop; 